module.exports = __webpack_public_path__ + "static/Metropolis-Bold-dea4998b081c6c1133a3b5b08ff2218c.otf";